import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AvailableTabProperties } from '../../../../interface/device-management.interface';

import DataManagement from './DataManagement';
import OcppLogs from './OcppLogs';
import Operations from './Operations';

/**
 * Function to display Ocpp tags
 * @returns
 */
export default function OcppConsole() {
  const { t } = useTranslation('devices');
  const [ocppConsoleTabs, setOcppConsoleTabs] = useState<AvailableTabProperties[]>([
    // {
    //   label: 'Data Management',
    //   key: 'device-management',
    //   isActive: false,
    // },
    {
      label: t('operations'),
      key: 'operations',
      isActive: true,
    },
    // {
    //   label: 'Settings',
    //   key: 'settings',
    //   isActive: false,
    // },
    // {
    //   label: 'Profile',
    //   key: 'profile',
    //   isActive: false,
    // },
    // {
    //   label: 'User',
    //   key: 'user',
    //   isActive: false,
    // },
  ]);

  /**
   * Function to switch the tab
   * @param {string} key
   */
  const handleSwitchTab = (key: string) => {
    setOcppConsoleTabs((previousTabs: AvailableTabProperties[]) =>
      previousTabs.map((tab) => {
        if (tab.key === key) {
          return {
            ...tab,
            isActive: true,
          };
        }
        return {
          ...tab,
          isActive: false,
        };
      }),
    );
  };

  return (
    <div className="device-ocpp-console-wrap">
      <div className="ocpp-console-tabs">
        {ocppConsoleTabs.map((tab) => (
          <div
            key={tab.key}
            className={`each-tab ${tab.isActive ? 'active' : ''}`}
            role="presentation"
            onClick={() => handleSwitchTab(tab.key)}>
            <h6>{tab.label}</h6>
            <div className="bottom-green" />
          </div>
        ))}
      </div>
      <div className="device-ocpp-console-container">
        {(() => {
          const activeTab = ocppConsoleTabs.find((tab) => tab.isActive);
          let dataToShow = null;
          if (activeTab) {
            switch (activeTab.key) {
              case 'device-management':
                dataToShow = <DataManagement />;
                break;
              case 'operations':
                dataToShow = <Operations />;
                break;
              default:
                dataToShow = null;
            }
          }
          return dataToShow;
        })()}
      </div>
      <OcppLogs />
      <div />
    </div>
  );
}
